const topics = [
  { name: '异世界触手', heat: '12.5万', rank: 1 },
  { name: '奇幻触手', heat: '9.8万', rank: 2 },
  { name: '科幻触手', heat: '8.2万', rank: 3 },
  { name: '都市触手', heat: '7.6万', rank: 4 },
  { name: '校园触手', heat: '6.3万', rank: 5 },
  { name: '冒险触手', heat: '5.9万', rank: 6 },
  { name: '搞笑触手', heat: '5.1万', rank: 7 },
  { name: '悬疑触手', heat: '4.7万', rank: 8 },
  { name: '热血触手', heat: '4.2万', rank: 9 },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 scroll-mt-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          触手漫画爱好者都在关注的热门标签
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#index"
              className="group flex items-center justify-between bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-100 text-primary-600 rounded-full text-xs font-bold">
                  {topic.rank}
                </span>
                <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {topic.name}
                </span>
              </div>
              <span className="text-xs text-foreground-400 flex items-center gap-1 whitespace-nowrap">
                <i className="ri-fire-line text-accent-500"></i>
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}